import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Locations from "@/components/site/Locations";
import ArcadiaStation from "@/components/site/ArcadiaStation";
import Studio from "@/components/site/Studio";
import Map from "@/components/site/Map";
import BaseCamp from "@/components/site/BaseCamp";
import Providers from "@/components/site/Providers";
import Distances from "@/components/site/Distances";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

const Home = () => (
  <main className="bg-[#050505] text-white grain">
    <Header />
    <Hero />
    <About />
    <Locations />
    <ArcadiaStation />
    <Studio />
    <Map />
    <BaseCamp />
    <Providers />
    <Distances />
    <Contact />
    <Footer />
  </main>
);

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#0a0a0a",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "#fafafa",
              borderRadius: 0,
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
